export class Quantity {
    constructor(containerId) {
        const self = this;
        self.container = document.getElementById(containerId);
        self.incrementButton = self.container.querySelector('.js-increment-btn');
        self.decrementButton = self.container.querySelector('.js-decrement-btn');
        self.input = self.container.querySelector('.js-quantity-input');
        self.step = parseFloat(self.input.dataset.step) || 1;
        if (typeof self.input.dataset.min !== 'undefined') {
            self.min = parseFloat(self.input.dataset.min);
        } else {
            self.min = null
        }
        if (typeof self.input.dataset.max !== 'undefined') {
            self.max = parseFloat(self.input.dataset.max);
        } else {
            self.max = null
        }

        self.input.increment = self.increment.bind(self);
        self.input.decrement = self.decrement.bind(self);
        self.incrementButton.addEventListener('click', function (e) {
            self.input.increment();
            const event = new CustomEvent('quantity', {detail: {type: 'increment'}});
            self.input.dispatchEvent(event);
        });
        this.decrementButton.addEventListener('click', function (e) {
            self.input.decrement();
            const event = new CustomEvent('quantity', {detail: {type: 'decrement'}});
            self.input.dispatchEvent(event);
        });

        //this.setValue(this.step);
    }

    increment() {
        let val = this.getValue();
        val = val + this.step;
        if (this.max !== null && val > this.max)
            val = this.max;
        //if (this.isFloat(val))

        this.setValue(val.toFixed(2));
    }

    decrement() {
        let val = this.getValue();
        val = val - this.step;
        if (this.min !== null && val < this.min)
            val = this.min;
        //if (this.isFloat(val))
        this.setValue(val.toFixed(2));
    }

    setValue(val) {
        this.input.value = val;
    }

    getValue() {
        return parseFloat(this.input.value);
    }

    isFloat(n) {
        return n === Number(n) && n % 1 !== 0;
    }
}
